import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { API } from 'api';
import {
  ExternalFeatureLayer,
  ExternalFeatureLayerServer,
} from 'features/mapping/mapping.types';
import { useAuthState } from 'state/useAuthState';

type UseExternalFeatureLayers = Omit<
  UseQueryResult<ExternalFeatureLayer[], Error>,
  'data'
> & {
  externalFeatureLayers: ExternalFeatureLayer[];
};

const fetchExternalFeatureLayers = async (): Promise<
  ExternalFeatureLayer[]
> => {
  const result = await API.get<ExternalFeatureLayerServer[]>(
    'feature_layer_mirrors/feature_layers/',
  );
  return result.data.map((layer) => ({
    ...layer,
    dateCreated: new Date(layer.dateCreated),
    dateModified: new Date(layer.dateModified),
  }));
};

export const useExternalFeatureLayers = (): UseExternalFeatureLayers => {
  const { isOrganizationUser } = useAuthState();

  const { data = [], ...results } = useQuery({
    queryKey: ['featureLayerMirrors'],
    queryFn: () => fetchExternalFeatureLayers(),
    staleTime: 1000 * 60 * 60, // 1 hour
    enabled: isOrganizationUser,
  });

  return { ...results, externalFeatureLayers: data };
};
